import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const AccountRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.accountList,
    children: [{ index: true, lazy: () => import('./account-list') }],
  },
  { path: ROUTES_PATH.myAccount, lazy: () => import('./my-account') },
];
